import { Checkbox, CommandItem, cn } from "ui";

import { normalizeLabelColor } from "src/lib/labelColors";

import { type LabelPickerLabel } from "./LabelPicker";

interface LabelPickerRowProps {
  label: LabelPickerLabel;
  isSelected: boolean;
  onToggle: (labelId: string) => void;
}

export function LabelPickerRow(props: LabelPickerRowProps) {
  return (
    <CommandItem
      value={props.label.name}
      onSelect={() => {
        props.onToggle(props.label.id);
      }}
      className="group"
    >
      <Checkbox
        checked={props.isSelected}
        tabIndex={-1}
        aria-hidden
        className={cn(
          "pointer-events-none",
          !props.isSelected &&
            "opacity-0 group-data-[selected=true]:opacity-100",
        )}
      />
      <span
        aria-hidden
        className="size-2.5 shrink-0 rounded-full border border-black/10"
        style={{ backgroundColor: normalizeLabelColor(props.label.color) }}
      />
      <span className="truncate font-medium">{props.label.name}</span>
    </CommandItem>
  );
}
